export default __webpack_public_path__ + "media/images/react_icons/constructor-1932f5945437c3dd9f348610b4376357.svg";